'use client';

/**
 * The ticker lookup on the 404 page. Kept as its own tiny client island so app/not-found.tsx can stay a
 * dependency-free server component (the 404 path must never depend on data or fail). On submit it routes
 * to the ticker's chart, which renders for ANY symbol, so a lost visitor recovers in one action and it
 * can never 404-loop.
 */
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { ArrowRight } from 'lucide-react';

export default function NotFoundSearch() {
  const router = useRouter();
  const [q, setQ] = useState('');

  const go = (e: React.FormEvent) => {
    e.preventDefault();
    const sym = q.trim().toUpperCase().replace(/[^A-Z.]/g, '').slice(0, 6);
    if (sym) router.push(`/chart/${sym}`);
  };

  return (
    <form onSubmit={go} className="mx-auto mt-6 flex max-w-md gap-2">
      <input
        type="text"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Look up a ticker (e.g. NVDA, TSLA)"
        aria-label="Look up a ticker"
        className="min-w-0 flex-1 rounded-xl border border-zinc-700 bg-zinc-900 px-4 py-3 text-sm text-zinc-100 placeholder:text-zinc-500 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/25"
      />
      <button
        type="submit"
        className="inline-flex shrink-0 items-center gap-1.5 rounded-xl bg-gradient-to-b from-sky-300 to-blue-500 px-4 py-3 text-sm font-bold text-slate-950 transition hover:from-sky-200 hover:to-blue-400"
      >
        Go <ArrowRight className="h-4 w-4" />
      </button>
    </form>
  );
}
